import APIClient from './APIClient';
import { ServiceVm } from '../common/types';

export default class ServicesService extends APIClient {
  async getAll (): Promise<Array<ServiceVm>> {
    const { data } = await this.get<Array<ServiceVm>>('Service');
    return data;
  }
}
